import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Card from './Card';
import Button from './Button';
import Input from './Input';

function Auth(props) {
  const {
    lastName,
    setLastName,
    userBadgeId,
    setUserBadgeId,
    login,
    adminPortal
  } = props

  useEffect(() => {
  }, [])

  return (
    <Card className='gap-5'>
      <form
        className='w-full flex justify-center items-center'
        onSubmit={e => {
          e.preventDefault();
          login();
        }}
      >
        <div className='w-11/12 text-black flex flex-col items-center justify-center gap-8'>
          {!adminPortal && (
            <div
              className='w-full text-black flex flex-col items-center justify-center'
            >
              <p className='text-center'>Please enter your last name and badge ID to manage your competition teams.</p>
            </div>
          )}
            <Input
              label={adminPortal ? 'Admin Name' : 'Last Name'}
              value={lastName}
              onChange={e => setLastName(e.target.value)}
            />

            <Input
              label={adminPortal ? 'Admin Passcode' : 'Badge ID'}
              value={userBadgeId}
              onChange={e => setUserBadgeId(e.target.value)}
            />

          <Button type="submit" onClickMethod={login}>Sign In</Button>
        </div>
      </form>

        {!adminPortal && (
          <Link
            to="/admin/login"
            className="text-black hover:text-yellow-500 text-sm mt-2"
          >
            Admin Portal 
          </Link>
        )}
    </Card>
  );
}

export default Auth;